import { Input, Select as MUSelect } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import React, { Component } from "react";
import styled from "styled-components";
import { inputStyle } from "../Input";

const Root = styled("div")`
    position: relative;
`;

const Placeholder = styled("div")<{ visible: boolean }>`
    color: ${(props) => props.theme.palette.grey[40]};
    display: ${(props) => (props.visible ? "block" : "none")};
    left: 10px;
    position: absolute;
    top: calc(50% - 8.5px);
`;

const CustomInput = ({ hasLabel, hasError, ...rest }: { hasLabel: boolean; hasError: boolean }) => <Input {...rest} />;

export const StyledInput = styled(CustomInput)`
    cursor: pointer;
    ${inputStyle};
    padding: 0;
    position: relative;

    div {
        height: 100%;
        padding: 0;

        div {
            align-items: center;
            display: flex;
            padding: 0 32px 0 10px;
        }
    }

    ::after,
    ::before {
        display: none;
    }
`;

export interface SelectOption {
    label: string;
    value: string | number;
}

export interface SelectProps {
    options: SelectOption[];
    onChange: (event: any) => void;
    value?: SelectOption["value"];
    [index: string]: any;
}

class Select extends Component<SelectProps> {
    public render() {
        const { value, onChange, options, placeholder, style, children, ...rest } = this.props;

        return (
            <Root style={style}>
                <MUSelect value={value} onChange={onChange} input={<StyledInput {...(rest as any)} />}>
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </MUSelect>
                <Placeholder visible={value === undefined || value === "" || value === -1}>{placeholder}</Placeholder>
            </Root>
        );
    }
}

export default Select;
